import { render } from "./AdminIfaSummaryView.vue?vue&type=template&id=dd7ec5cc&lang=pug"
import script from "./AdminIfaSummaryView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminIfaSummaryView.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__